module.exports = __webpack_public_path__ + "img/134.930f5708.png";